import { 
    SERVICE_SET_CROP_DIMENSIONS,   
    SET_IMAGE, SET_NAME, SET_FORMAT, CANVAS_SET_FORMAT, SET_PRESERVATION_PROPORTIONS, SET_DIMENSION, SET_ERROR, SET_PREVIEW_POSITION, CANVAS_SET_IMAGE, CANVAS_SET_DIMENSION, SHOW_POPUP, CANVAS_SET_FLIP_VERTICAL, CANVAS_SET_FLIP_HORIZONTAL, CANVAS_SET_IS_CHANGED, SET_ROTATED, CANVAS_SET_SAVE_PROPORTIONS, CANVAS_SET_CROP_DIMENSIONS, CANVAS_SET_VALIDATION, SERVICE_SET_CROP_POSITION } from "./contstants";

export const setImage = (image: File) => {
    const imageStr = URL.createObjectURL(image);
    
    
    return {
        setImage: { type: SET_IMAGE, image: imageStr },
        setName: { type: SET_NAME, name: image.name },
        setFormat: { type: SET_FORMAT, format: image.type },
    }
}

export const setDimension: Function = (height: number, width: number) => {
    return {
        image: { type: SET_DIMENSION, width: width, height: height },
        canvas: { type: CANVAS_SET_DIMENSION, width: width, height: height }
    }
}

export const clearError: Function = () => {
    return { type: SET_ERROR, error: null };
}

export const setError: Function = (error: string) => {
    return { type: SET_ERROR, error: error };
}

export const showPopup: Function = (selectedPopup: string) => {
    return { type: SHOW_POPUP, selectedPopup: selectedPopup }
}

export const setFlipVertical: Function = (isVertical: boolean) => {
    return { type: CANVAS_SET_FLIP_VERTICAL, isFlipVertical: !isVertical };
}

export const setFlipHorizontal: Function = (isHorizontal: boolean) => {
    return { type: CANVAS_SET_FLIP_HORIZONTAL, isFlipHorizontal: !isHorizontal };
}

export const setChanged: Function = () => {
    return ({ type: CANVAS_SET_IS_CHANGED, isChanged: true });
 }

 export const setCropProportions: Function = (isSave) => {
    return ({ type: CANVAS_SET_SAVE_PROPORTIONS, cropIsSaveProportions: isSave });
 }

 export const setCropValidation: Function = (validationInfo) => {
    return ({ type: CANVAS_SET_VALIDATION, cropValidation: validationInfo});
 }

 //New

 export const setCropDimensions: Function = (width: number, height: number) => {
    return ({ type: SERVICE_SET_CROP_DIMENSIONS, cropDimensions: { width: width, height: height } });
 }

 export const setCropPosition: Function = (x: number, y: number) => {
    return ({ type: SERVICE_SET_CROP_POSITION, cropPosition: { x: x, y: y } });
 }

 
 export const clearRotatePosition: Function = () => {
    return { type: SET_PREVIEW_POSITION, previewPosition: [] };
 }


 export const canvasSetDimension: Function = (height: number, width: number) => {
    return{ type: CANVAS_SET_DIMENSION, height: height, width: width };
}

export const canvasSetRotationAngle: Function = (rotationAngle: number) => {
    return { type: SET_ROTATED, rotationAngle: rotationAngle };
 }

 export const resizeSetSaveProportions: Function = (isSave: boolean) => {
        return { type: SET_PRESERVATION_PROPORTIONS, isPreservationProportions: isSave };
    }

export const resizeSetFormat: Function = (format: string) => {
    return { type: CANVAS_SET_FORMAT, format: format };
}

